/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Person from 'components/Person/Person';
import './Business.scss';

/**
 * This is the Business component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Business({ label, name, persons, cv }) {
  const ariaLabel = label ? `${label}: ${name}` : name;
  return (
    <section role="group" className="business" aria-label={ariaLabel}>
      <h3 aria-hidden>
        {label ? <span>{label}</span> : null}
        <strong>{name}</strong>
      </h3>
      <div>
        {persons.map(({ id, ...props }) => (
          <Person key={id} {...props} cv={cv} />
        ))}
      </div>
    </section>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Business.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  cv: PropTypes.string.isRequired,
  persons: PropTypes.array.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Business.defaultProps = {
  label: null,
  cv: 'Show CV',
  persons: [],
};

export default Business;
